import React from 'react';
import ReactDOM from 'react-dom';
//import { PersistGate } from 'redux-persist/integration/react'
//import { store, persistor } from "./store/index";
import { store } from "./store/index";
import { Provider } from "react-redux";

import './index.css';
import App from './App';

import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
    <Provider store={store}>
        {/* <PersistGate loading={null} persistor={persistor}> */}
            <App/>
        {/* </PersistGate> */}
    </Provider>,
    document.getElementById('root')
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js